import { render, staticRenderFns } from "./AppCookiePolicy.vue?vue&type=template&id=b09fe4fe&"
import script from "./AppCookiePolicy.vue?vue&type=script&lang=js&"
export * from "./AppCookiePolicy.vue?vue&type=script&lang=js&"
import style0 from "./AppCookiePolicy.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/var/www/html/insights/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VSnackbar } from 'vuetify/lib'
installComponents(component, {VBtn,VFlex,VLayout,VSnackbar})
